import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer } from 'react-sortable-hoc';
import { showModal, hideModal } from '../../../../actions/ModalActions';
import { getPhotos, editPhoto } from '../../../../actions/website/entities/PhotosActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import { saveCrop, tempUploadPromise } from '../../../../actions/website/FileUploadActions';
import FileInputButton from '../../../common/form/FileInputButton';
import { togglePage } from '../../../../actions/website/PageActions';
import { getImageUrl } from '../../../../cards/util/imageHelper';
import EditPageForm from './EditPageCommon/EditPageFormContainer/EditPageFormContainer';
import EditPageHeader from './EditPageCommon/EditPageHeader';
import EditPageAddEntity from './EditPageCommon/EditPageAddEntity';
import { EntityDesciption } from './EditPageCommon/EditPageSortableList';

const PhotoDetails = entity => {
  const photoId = entity && entity.image_id;
  const photoCaption = entity && entity.caption;

  return (
    <>
      {photoId && (
        <div
          className="photo-preview"
          style={{ backgroundImage: `url(${getImageUrl(photoId)}?w=100&h=100)` }}
        />
      )}
      {photoCaption && <EntityDesciption description={photoCaption} addClass="photo-caption" />}
    </>
  );
};

class Photos extends Component {
  componentDidMount() {
    const { getPhotoEntities } = this.props;
    getPhotoEntities();
  }

  componentWillReceiveProps(nextProps) {
    const { openCropModal, openSaveModal, closeModal } = this.props;
    if (
      nextProps.photoFilePreview.s3_key &&
      this.props.photoFilePreview.s3_key !== nextProps.photoFilePreview.s3_key
    ) {
      openCropModal(nextProps.photoFilePreview);
    } else if (
      nextProps.photoFilePreview.uuid &&
      this.props.photoFilePreview.uuid !== nextProps.photoFilePreview.uuid
    ) {
      closeModal();
      openSaveModal(nextProps.photoFilePreview);
    }
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const {
      photos,
      orderedIds,
      onEdit,
      onDelete,
      page,
      themeKey,
      onPhotoSelect,
      photoFilePreview,
      onPageToggle,
    } = this.props;
    const photoCount = Object.keys(photos).length;
    const pageType = page && page.type;
    const { env } = window.zola;
    let photoLimit;
    if (env === 'development') {
      photoLimit = 25;
    } else if (env === 'staging') {
      photoLimit = 25;
    } else {
      photoLimit = 100;
    }
    const nearPhotoLimit = photoCount >= photoLimit - 5 && photoCount < photoLimit;
    const atPhotoLimit = photoCount >= photoLimit;

    const button = (
      <div>
        <div className="upload-photo">
          <FileInputButton
            inputId="new_photo"
            onSelect={onPhotoSelect}
            types="image/*"
            btnClass="margin-top margin-bottom uploadPhoto__button"
            btnText={photoFilePreview.busy ? 'Uploading...' : 'Add A Photo'}
            busyOverride
            busy={photoFilePreview.busy}
            disabledOverride={atPhotoLimit}
          />
          {nearPhotoLimit && (
            <div className="photo-limit">
              <p>
                {photoCount}/{photoLimit} Photos Added
              </p>
            </div>
          )}
          {atPhotoLimit && (
            <div className="photo-limit">
              <p>Limit Reached: {photoLimit} Photos Added</p>
            </div>
          )}
        </div>
        &nbsp;
        <small>(max file size 5 MB)</small>
      </div>
    );

    return (
      <div>
        {themeKey && <EditPageHeader page={page} themeKey={themeKey} onPageToggle={onPageToggle} />}

        <>
          <EditPageForm page={page} />
          <EditPageAddEntity
            entityName="Photo"
            onAddButton={button}
            pageType={pageType}
            orderedIds={orderedIds}
            entities={photos}
            onEdit={onEdit}
            onDelete={onDelete}
            entityDetail={PhotoDetails}
          />
        </>
      </div>
    );
  }
}

Photos.propTypes = {
  photos: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getPhotoEntities: PropTypes.func.isRequired,
  openCropModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
  onPhotoSelect: PropTypes.func,
  photoFilePreview: PropTypes.shape({ uuid: PropTypes.string, s3_key: PropTypes.string }),
  onPageToggle: PropTypes.func,
  openSaveModal: PropTypes.func,
  closeModal: PropTypes.func,
};

const mapStateToProps = state => ({
  photos: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.PHOTO],
  themeKey: state.wedding.theme.key,
  photoFilePreview: state.website.entities.filePreview.new_photo || {},
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => {
    dispatch(moveEntity(oldIndex, newIndex));
  },
  openCropModal: image => {
    dispatch(
      showModal('CROP_MODAL', {
        aspectRatio: 1,
        imageUrl: image.url,
        onCropSelect: crop => {
          dispatch(saveCrop(image.s3_bucket, image.s3_key, crop, image.content_type, 'new_photo'));
        },
        subcopy: "Don't want a white border? Drag the corners and crop your photo to a square.",
      })
    );
  },
  openSaveModal: image => {
    dispatch(addEntity());
    dispatch(showModal('PHOTO', { newPhoto: image }, { size: 'md' }));
  },
  getPhotoEntities: () => {
    dispatch(getPhotos());
  },
  onEdit: photo => {
    dispatch(editPhoto(photo));
    dispatch(showModal('PHOTO', { isUpdate: true }, { size: 'md' }));
  },
  onDelete: entity => {
    dispatch(showModal('DELETE_ENTITY', { entity }));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
  onPhotoSelect: file => dispatch(tempUploadPromise(file, 'new_photo')),
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  closeModal: () => dispatch(hideModal()),
});

const SortablePhotos = SortableContainer(Photos);

export default connect(mapStateToProps, mapDispatchToProps)(SortablePhotos);
